export const links = {
  termsAndConditions: 'https://www.playdreamscape.com/terms-and-conditions/',
  privacyPolicy: 'https://www.playdreamscape.com/privacy-policy/'
};
